import { Scope, captureException, captureMessage } from '@sentry/react';
import type { SeverityLevel } from '@sentry/react';

export const configureSentry = (severity?: SeverityLevel) => {
  const scope = new Scope();
  scope.setLevel(severity ?? 'error');

  const withSentry =
    <V>(fn: (scope: Scope) => Promise<V>) =>
    async (): Promise<V> => {
      try {
        return await fn(scope);
      } catch (e) {
        captureException(e, Scope.clone(scope));
        throw e;
      }
    };

  return { withSentry, scope };
};

export const configureSentrySync = (severity?: SeverityLevel) => {
  const scope = new Scope();
  scope.setLevel(severity ?? 'error');

  const withSentry =
    <V>(fn: (scope: Scope) => V) =>
    (): V => {
      try {
        return fn(scope);
      } catch (e) {
        captureException(e, Scope.clone(scope));
        throw e;
      }
    };

  return { withSentry, scope };
};

export const configureSentryLogger = (severity?: SeverityLevel) => {
  const { scope } = configureSentrySync(severity ?? 'log');
  const logger = (...data: any[]) => {
    const strings = data.map(entry =>
      typeof entry !== 'undefined' ? (entry as object).toString() : 'undefined',
    );
    captureMessage(strings.join(' '), scope);
  };

  return { logger, scope };
};
